import { Component, OnInit } from '@angular/core';
declare var $: any;


@Component({
  selector: 'app-sc-twothree-twofour',
  templateUrl: './sc-twothree-twofour.component.html',
  styleUrls: ['./sc-twothree-twofour.component.scss']
})
export class ScTwothreeTwofourComponent implements OnInit {
  pdfSrc: string[] = [
    'https://drive.google.com/file/d/17PdlSMyNhai-an0f_9TXyXnakDXioJBp/preview',
    'https://drive.google.com/file/d/1HuhOMTdJ-HkpVCOWWaTJ-RVI2YLbPqKv/preview',
    'https://drive.google.com/file/d/1o9UFRW7PwJ8Lz_5tM3XvuB2R_hU9RMi_/preview',
    'https://drive.google.com/file/d/1v7MS0hAPsQLkLaABbrR6kvrUcMfps_yf/preview',
    'https://drive.google.com/file/d/17GN6-Bu02v3WAg4dgpDGIptIgKuxPQH3/preview',
    'https://drive.google.com/file/d/1ZtCvBK7ciJt9VVZ9hlFLmB23pp2_TtK3/preview',
    'https://drive.google.com/file/d/1Ntfm1oCjGnvA7eTU6w77bSk_mRVYHjZv/preview',
    'https://drive.google.com/file/d/1johxdLfxTvY0g9IHZcF7n008Ui1onOsI/preview',
    'https://drive.google.com/file/d/1I-FPRd5tDqC_gpssvuRzwmC9ucnyCDzI/preview',
    'https://drive.google.com/file/d/1AqAkgXqSC_MY2WcZJ-9LKtCYZmEUjIgi/preview',
    'https://drive.google.com/file/d/1mdKsZkmpkzwgiqmGqd3Jm0P-qi_A4G2P/preview'
  ];

  src: string;
  isLoading = true;

  ngOnInit(): void {
    this.changeRoute('1');
  }

  changeRoute(year: string) {
    this.isLoading = true;

    $('.first,.second,.third,.four,.five,.six,.seven,.eight,.nine,.ten,.eleven').removeClass('active');

    if (year == '1') { $('.first').addClass('active'); this.src = this.pdfSrc[0]; }
    if (year == '2') { $('.second').addClass('active'); this.src = this.pdfSrc[1]; }
    if (year == '3') { $('.third').addClass('active'); this.src = this.pdfSrc[2]; }
    if (year == '4') { $('.four').addClass('active'); this.src = this.pdfSrc[3]; }
    if (year == '5') { $('.five').addClass('active'); this.src = this.pdfSrc[4]; }
    if (year == '6') { $('.six').addClass('active'); this.src = this.pdfSrc[5]; }
    if (year == '7') { $('.seven').addClass('active'); this.src = this.pdfSrc[6]; }
    if (year == '8') { $('.eight').addClass('active'); this.src = this.pdfSrc[7]; }
    if (year == '9') { $('.nine').addClass('active'); this.src = this.pdfSrc[8]; }
    if (year == '10') { $('.ten').addClass('active'); this.src = this.pdfSrc[9]; }
    if (year == '11') { $('.eleven').addClass('active'); this.src = this.pdfSrc[10]; }
  }
  hideLoader() {
    this.isLoading = false;
  }


}
